import type { ComponentProps } from "react";
import { cn } from "@/lib/utils";
import "./spinner.css";

type SpinnerProps = ComponentProps<"output"> & { size?: number };

export function Spinner({ className, size = 16, style, ...props }: SpinnerProps) {
  return (
    <output
      aria-label="Cargando"
      className={cn("inline-flex shrink-0", className)}
      style={{ width: size, height: size, ...style }}
      {...props}
    >
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="310 4 223 212" className="size-full" aria-hidden="true">
        <path
          className="bpm-spinner-trace"
          pathLength="1"
          strokeWidth={Math.max(4, 223 / size)}
          d="M326 200H369V86L402 200H440L474 86V200H517V20H456L421 134L387 20H326V200Z"
        />
      </svg>
    </output>
  );
}
